module.exports = __webpack_public_path__ + "img/alert-error.f0133a86.svg";